import { Box, Typography, Container } from "@mui/material";

const brandBlue = "#1a237e";
const brandRed = "#d50000";

export default function MissionVisionValues() {
  const items = [
    {
      title: "Mission",
      text: "To deliver high-quality metal engineering solutions with speed, safety and precision.",
    },
    {
      title: "Vision",
      text: "To be a trusted leader in acoustic enclosures, fuel tanks and industrial metal fabrication.",
    },
    {
      title: "Values",
      text: "Quality • Integrity • Innovation • Safety • Customer Focus",
    },
  ];


  return (
    <Box
      sx={{
        py: { xs: 8, md: 12 },
        // background: "linear-gradient(135deg, #0d0f19, #111627, #0b0e18)",
        background:
          "linear-gradient(135deg, rgba(26,35,126,0.8), rgba(213,0,0,0.8))",
        color: "#fff",
      }}
    >
      <Container maxWidth="lg">
        {/* Heading */}
        <Typography
          variant="h4"
          fontWeight={800}
          sx={{
            mb: 4,
            color: "#fff",
            fontSize: { xs: "1.5rem", md: "2.3rem" },
            textAlign: "center",
          }}
        >
          Mission, Vision & Core Values
        </Typography>

        {/* Red underline */}
        {/* <Box
          sx={{
            width: 80,
            height: 4,
            background: brandRed,
            borderRadius: 2,
            mx: "auto",
            mb: 6,
          }}
        /> */}

        {/* Items */}
        <Box
          sx={{
            display: "flex",
            gap: 4,
            flexWrap: "wrap",
            justifyContent: "center",
          }}
        >
          {items.map((item, i) => (
            <Box
              key={i}
              sx={{
                flex: "1 1 280px",
                p: 4,
                borderRadius: 4,
                background:
                  "linear-gradient(135deg, rgba(26,35,126,0.8), rgba(213,0,0,0.8))",
                boxShadow: "0 10px 25px rgba(0,0,0,0.4)",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                "&:hover": {
                  transform: "translateY(-6px)",
                  boxShadow: "0 14px 35px rgba(0,0,0,0.5)",
                },
              }}
            >
              <Typography
                variant="h6"
                fontWeight={700}
                sx={{ mb: 2, color: "#fff" }}
              >
                {item.title}
              </Typography>
              <Typography sx={{ color: "#e0e0e0", lineHeight: 1.8 }}>
                {item.text}
              </Typography>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
}
